import React, { useState} from "react";
import {Box, Typography,} from "@mui/material";
import META_TRAVEL_ADS_LANGUAGE_CRITERION from "../../../constants/meta-travel-ads-criterion/metaTravelAdsLanguageCriterion";
import {validateLanguage} from "../../../Utils/validators/campaignSettingsValidators";
import { ArrowDropDown } from "@mui/icons-material";
import TextInput from "components/TextInput";
import LanguageDropDown from "./LanguageDropDown";
import "./LanguageSelection.scss";

const LanguageSelection = ({ selectedLanguage, setSelectedLanguage, errors }) => {
    const [_,setLanguageStatus] = useState(null);
    const languageButtonRef = React.useRef(null);
    const [languageMenuOpen, setLanguageMenuOpen] = useState(false);

    const handleLanguageBlur = async (langs) => {
        const result = await validateLanguage(langs);
        if(result.success) {
          delete errors.campaignLang;
        }
        setLanguageStatus(
            result.success
                ? { success: true, error: null }
                : { success: false, error: result.error || "Invalid language" }
        );
    };  
    
    console.log(errors, "language errors");
    

    return (
      <Box className="languageSelection">
        <Box display="flex" alignItems="center">
          <Typography className="sectionTitle">
            Select Your Target Audience Language
          </Typography>
        </Box>
        <Box mt={1} pl={"16px"}>
          <div ref={languageButtonRef} className="wrapper">
            <TextInput
              autoComplete="off"
              placeholder={"Select Languages"}
              type={"text"}
              readOnly
              value={
                selectedLanguage.length > 0
                  ? selectedLanguage.length <=2
                    ? selectedLanguage.map((lang) => lang.language_name).join(", ")
                    : `${selectedLanguage.slice(0,2).map((lang) => lang.language_name).join(", ")} and ${selectedLanguage.length - 2} others selected`
                  : ""
              }
              sx={{
                backgroundColor: "white",
                fontSize: "12px",
                fontWeight: "400",
                paddingLeft: "4px",
                minWidth: "360px",
                height: "28px"
              }}
              endAdornment={<ArrowDropDown sx={{ color: "#BAB7B7" }} />}
              onClick={(e) => {
                setLanguageMenuOpen(true);
              }}
              error={Boolean(errors?.campaignLang)}
            />
            {errors?.campaignLang && <span className="error-text">{errors.campaignLang}</span>}
          </div>
          <LanguageDropDown
            anchorEl={languageButtonRef.current}
            open={languageMenuOpen}
            languages={META_TRAVEL_ADS_LANGUAGE_CRITERION}
            selectedLanguage={selectedLanguage}
            setSelectedOtherLanguages={setSelectedLanguage}
            onClose={() => {
              setLanguageMenuOpen(false);
              handleLanguageBlur([...selectedLanguage?.map(lang => String(lang.id_lang))])
            }}
          />
        </Box>
      </Box>
    );
};

export default LanguageSelection;
